import { TagToComponentMap } from "nwon-html-to-react";

/**
 * The Footnote area automatically get a headline attached.
 */
export const mappedFigures: TagToComponentMap = {
  figure: ({ children, attributes }) => {
    return <div {...attributes}>{children}</div>;
  },
};
